"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeIp = void 0;

var _parseIp = require("./parse-ip");

var _convertIpToString = require("./convert-ip-to-string");

var REGEXP_NON_NUMERIC_EXCEPT_DOT = /[^0-9.]+/g;

var isIpEmpty = function isIpEmpty(text) {
  return text.replace(/( |\.)*/, '') === '';
};
/**
 * @description
 * return normalized IP address
 * @Function
 *
 * @name skybase-components.sb-ipv4-input.utils#normalizeIp
 * @param {String} text
 * @return {String}
 */


var normalizeIp = function normalizeIp(text) {
  var cleanedText = text.replace(REGEXP_NON_NUMERIC_EXCEPT_DOT, '');
  return !isIpEmpty(cleanedText) ? (0, _convertIpToString.convertIpToString)((0, _parseIp.parseIp)(cleanedText)) : '';
};

exports.normalizeIp = normalizeIp;
//# sourceMappingURL=normalize-ip.js.map